<template>
  <div>
    <pdl-callout v-if="showErrorCallout" kind="error" qaid="product-feedback__global-errors">
      <template #content>
        <span>{{ $t('form.global.error') }}</span>
      </template>
    </pdl-callout>
    <pdl-section-header size="xl" :is-dividing="true">
      <template #content>
        <pdl-heading :level="1" qaid="product-feedback__header">
          {{ $t('warrantyClaims.B2B.feedback.submitProduct') }}
        </pdl-heading>
      </template>
    </pdl-section-header>

    <section class="mt-5">
      <!-- Header -->
      <pdl-section-header size="md" :is-dividing="true">
        <template #content>
          <pdl-heading :level="3" qaid="product-feedback__contact-info-header">
            {{ $t('warrantyClaims.B2B.feedback.contact') }}
          </pdl-heading>
        </template>
      </pdl-section-header>

      <!-- Contact Info -->
      <div class="grid-x grid-margin-x">
        <div class="cell medium-4">
          <pdl-form-group
            type="text"
            name="contactName"
            qaid="product-feedback__contact-person"
            :error="getErrorMessage('contactName')"
            :label="$t('text.contactPerson')"
            :required="true"
            :model-value="contactName"
            @update:modelValue="updateFieldBasedUserData('contactName', $event)"
            @blur="validateFieldOnBlur('contactName')"
          />
        </div>
        <div class="cell medium-4">
          <pdl-form-group
            type="text"
            name="contactPhoneNumber"
            qaid="product-feedback__contact-phone"
            :maxlength="26"
            :error="getErrorMessage('contactPhoneNumber')"
            :label="$t('text.address.phone')"
            :model-value="contactPhoneNumber"
            @update:modelValue="updateFieldBasedUserData('contactPhoneNumber', $event)"
            @blur="validateFieldOnBlur('contactPhoneNumber')"
          />
        </div>
        <div class="cell medium-4">
          <pdl-form-group
            type="text"
            name="contactEmail"
            qaid="product-feedback__contact-email"
            :error="getErrorMessage('contactEmail')"
            :label="$t('address.email')"
            :required="true"
            :model-value="contactEmail"
            @update:modelValue="updateFieldBasedUserData('contactEmail', $event)"
            @blur="validateFieldOnBlur('contactEmail')"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import {PdlCallout} from '@pedal/pdl-callout';
import {PdlFormGroup} from '@pedal/pdl-form-group';
import {PdlSectionHeader, PdlHeading} from '@pedal/pdl-section-header';
import {TrekValidationMixin} from '@/utils/validation/trek-validation-mixin';

export default {
  components: {PdlCallout, PdlFormGroup, PdlSectionHeader, PdlHeading},
  mixins: [TrekValidationMixin],
  props: {
    showSuccess: Boolean,
  },
  setup() {
    return {
      ...TrekValidationMixin.setup(),
    };
  },
  computed: {
    ...mapState('productFeedback', ['feedbackData', 'showErrorCallout']),
    contactName() {
      return this.feedbackData.contactName || '';
    },
    contactPhoneNumber() {
      return this.feedbackData.contactPhoneNumber || '';
    },
    contactEmail() {
      return this.feedbackData.contactEmail || '';
    },
  },

  validations() {
    const validations = {
      contactName: {
        required: this.trekValidators.required('text.contactPerson'),
      },
      contactPhoneNumber: {
        maxLength: this.trekValidators.maxLength('text.address.phone', 26),
      },
      contactEmail: {
        required: this.trekValidators.required('address.email'),
      },
    };
    return validations;
  },
  methods: {
    ...mapMutations('productFeedback', ['updateFeedbackProperty', 'updateUserData', 'updateFlag']),
    updateFieldBasedUserData(propName, event) {
      if (this.v$[propName].$error) this.updateFlag({flagName: 'showErrorCallout', value: true});
      this.updateUserData({propName, value: event});
    },
    validateFieldOnBlur(propName) {
      this.v$[propName].$validate().then(() => {
        if (this.v$[propName].$error) this.updateFlag({flagName: 'showErrorCallout', value: true});
      });
    },
  },
};
</script>
